var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as s from './PriceQuotesBusinessInfo.scss';
import * as get from 'lodash.get';
import { Box, Text } from 'wix-style-react';
import { getResizedImageUrl } from '@wix/media-manager';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { translate } from 'react-i18next';
import { Placement, } from '@wix/ambassador-wix-quotes-web/types';
import { WithBusinessInfoLoader, } from '../../loaders/loaders-builder';
import { isMobileView } from '../../../core/isMobileView';
var customaizeInvoiceVerticalLayoutLineProps = {
    size: 'tiny',
    secondary: true,
    weight: 'thin',
};
var BusinessInfoLine = function (_a) {
    var children = _a.children, verticalLayout = _a.verticalLayout, props = __rest(_a, ["children", "verticalLayout"]);
    return (React.createElement(Box, { wordBreak: 'break-word' },
        React.createElement(Text, __assign({ size: "tiny", secondary: true, weight: "thin" }, (verticalLayout ? customaizeInvoiceVerticalLayoutLineProps : {}), props, { className: s.customizeBusinessInfoLine + " " + (props.className || '') }), children)));
};
//FIXME use this is failing in case of logo = "//static.wixstatic.com/media/", need to have a better fix
var logoFitUrl = function (logo, width) {
    var logoFilename = logo.match(/(?:[^\/]+)$/)[0];
    var logoResizedUrl = getResizedImageUrl(logoFilename, width, 100);
    return logoResizedUrl.replace('/fill/', '/fit/');
};
var PriceQuotesBusinessInfoComponent = function (_a) {
    var t = _a.t, businessInfo = _a.businessInfo, verticalLayout = _a.verticalLayout, _b = _a.onImageReady, onImageReady = _b === void 0 ? function () { } : _b, businessCustomFields = _a.businessCustomFields;
    var name = businessInfo.name, email = businessInfo.email, phone = businessInfo.phone, companyId = businessInfo.companyId, logo = businessInfo.logo;
    var description = get(businessInfo, 'businessAddress.description.content');
    var placement = get(businessInfo, 'businessAddress.description.placement');
    var city = get(businessInfo.address, 'city');
    var state = get(businessInfo.address, 'state');
    var country = get(businessInfo.address, 'country');
    var streetName = get(businessInfo.address, 'streetAddress.name');
    var streetNumber = get(businessInfo.address, 'streetAddress.number');
    var street = get(businessInfo.address, 'street');
    var zip = get(businessInfo.address, 'zip');
    var localizedLocation = addressFormatter({
        t: t,
        city: city,
        state: state,
        country: country,
        zip: zip,
        streetNumber: streetNumber,
        streetName: streetName,
        street: street,
    });
    var Location = function () {
        return !!localizedLocation && (React.createElement(BusinessInfoLine, { dataHook: "business-address", verticalLayout: true }, localizedLocation));
    };
    var Description = function () {
        return !!description && (React.createElement(BusinessInfoLine, { dataHook: "business-address-description", verticalLayout: true }, description));
    };
    var hasLogo = function () { return logo && logo.match(/(?:[^\/]+)$/); };
    var Logo = function () {
        var handleLogoNotExist = function () {
            onImageReady();
            return (React.createElement("div", { style: { height: '10px' } }));
        };
        var width = verticalLayout ? 311 : 100;
        return hasLogo() ? (React.createElement("div", { className: s.logo, "data-hook": "business-logo" },
            React.createElement("img", { decoding: "sync", src: logoFitUrl(logo, width), onError: function (_a) {
                    var image = _a.target;
                    image.parentElement.style.display = 'none';
                    onImageReady();
                }, onLoad: onImageReady }))) : (handleLogoNotExist());
    };
    var customFields = function () {
        return businessCustomFields.map(function (_a, index) {
            var displayName = _a.displayName, value = _a.value;
            return (React.createElement("div", { key: index },
                React.createElement(BusinessInfoLine, { verticalLayout: true, dataHook: displayName + "-" + index + "-custom-field", className: s.customFieldLine }, t('invoice-view:price-quote.view.custom-field', {
                    displayName: displayName,
                    value: value,
                }))));
        });
    };
    var renderAddress = function () {
        switch (placement) {
            case Placement.Replace:
                return description ? React.createElement(Description, null) : [React.createElement(Location, { key: "location" })];
            case Placement.Before:
                return [React.createElement(Description, { key: "description" }), React.createElement(Location, { key: "location" })];
            case Placement.After:
                return [React.createElement(Location, { key: "location" }), React.createElement(Description, { key: "description" })];
            default:
                return [React.createElement(Location, { key: "location" })];
        }
    };
    var hasCustomFields = businessCustomFields && businessCustomFields.length > 0;
    return (React.createElement("div", { className: s.businessInfo + " " + (verticalLayout ? s.verticalLayout : '') },
        React.createElement(Logo, null),
        React.createElement(Box, { direction: isMobileView() ? 'vertical' : 'horizontal' },
            React.createElement("div", { className: s.businessInfoDetails, "data-hook": "business-info" },
                !!name && (React.createElement(BusinessInfoLine, { className: s.businessName, weight: "bold", dataHook: "business-name", verticalLayout: true }, name)),
                renderAddress(),
                !!email && (React.createElement(BusinessInfoLine, { dataHook: "business-email", verticalLayout: true }, email)),
                !!phone && (React.createElement(BusinessInfoLine, { dataHook: "business-phone", verticalLayout: true }, t('invoice-view:price-quote.view.business.phone', { phone: phone }))),
                !!companyId && (React.createElement(BusinessInfoLine, { dataHook: "business-company-id", verticalLayout: true }, t('invoice-view:price-quote.view.business.company-id', {
                    companyId: companyId,
                })))),
            hasCustomFields && (React.createElement("div", { className: s.businessInfoDetails + " " + s.businessCustomFields, "data-hook": "business-custom-fields", style: {
                    width: !hasLogo() && '210px',
                    marginTop: hasLogo() ? '47px' : '104px',
                } }, customFields())))));
};
export var PriceQuotesBusinessInfo = WithBusinessInfoLoader(translate(['invoice-view', 'locale-data'])(PriceQuotesBusinessInfoComponent));
//# sourceMappingURL=PriceQuotesBusinessInfo.js.map